import { FieldProps, LinkField, useFieldHelper } from 'framework/ui/field';
import AnalyticsClientIdTooltip from 'domain/sales/lead/shared/field/AnalyticsClientIdTooltip';
import useConfiguration from 'infrastructure/configurationService/configurationService';

const AnalyticsClientIdField = (props: FieldProps<string> | undefined) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { googleAnalyticsUserLink } = useConfiguration();

  const clientId = getValue();

  const getLink = () => {
    return clientId ? `${googleAnalyticsUserLink}${clientId}` : null;
  };

  return (
    <LinkField
      linkText={clientId}
      label={
        <>
          {getLabel()}
          <AnalyticsClientIdTooltip />
        </>
      }
      value={getLink()}
    />
  );
};

export default AnalyticsClientIdField;
